<template>
    <div class="page pay">
        <div class="order-info">
            <div class="session-info">
                <div class="order-item-img">
                    <img class="img" :src="detail.pic" />
                </div>
                <div class="order-item-content">
                    <div class="film-name">{{ detail.filmName }}</div>
                    <div class="time">{{ detail.showDateOfChinese }} {{ detail.movieInformation }}</div>
                    <div class="cinema-name">{{ detail.cinemaName }}</div>
                    <div class="hall-name">{{ detail.hallName }}</div>
                    <div class="seat-list">
                        <div class="seat-item" v-if="detail.seats" v-for="(item, index) in detail.seats" :key="index">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="dividing-line">
                <div class="line-item"></div>
            </div>
            <div class="tip-list" @click="showTip">
                <div class="tip-item">
                    <img src="@/assets/icons/icon-close-red.png" />
                    <span>不支持退票</span>
                </div>
                <div class="tip-item">
                    <img src="@/assets/icons/icon-close-red.png" />
                    <span>不支持改签</span>
                </div>
                <div class="tip-item">
                    <span>查看详情</span>
                </div>
            </div> -->
        </div>
        <!-- <div class="model seat">
            <div class="line">
                <div class="line-title">座位</div>
                <div class="line-value secondary">
                    {{
                        detail.seats &&
                            detail.seats
                                .map(v => {
                                    return v.name;
                                })
                                .join(';')
                    }}
                </div>
            </div>
            <div class="accept-adjust-box">
                <div class="accept-adjust-title">无座时同意调座</div>
                <div
                    class="status"
                    @click="switchAcceptAdjust"
                    :class="{ 'accept-adjust': acceptAdjust }"
                ></div>
                <div class="accept-adjust-tip">
                    特惠票为低价抢购票，非下单实时锁座，您所选的座位若未购买成功，系统会为您自动匹配相邻的最佳观影位置出单。
                </div>
            </div>
            <div class="line">
                <div class="line-title">座位备选</div>
                <div class="line-value secondary">{{acceptAdjust ? "同意调座" : "不同意调座"}}</div>
            </div>
        </div> -->
        <template v-if="detail.cardAddPoint > 0">
            <div class="ticket-type-box small-spacing">
                <div class="ticket-type-item" :class="{ select: chooseIndex == 0 }" @click="clickChoose2(0)">
                    <img
                        class="status-img"
                        :src="
                            require(chooseIndex == 0
                                ? '@/assets/icons/icon-choose.png'
                                : '@/assets/icons/icon-unchoose.png')
                        "
                    />
                    <div class="line">
                        <div class="name">特惠购票</div>
                        <div class="price">
                            <span class="text">¥{{ detail.notUseCardUnitPrice }}/张</span>
                            <!-- <span class="company">/张</span> -->
                        </div>
                    </div>
                    <div class="tip">
                        <div class="line">优惠较大，出票时间在15~50分钟</div>
                    </div>
                </div>
            </div>
            <div class="ticket-type-box small-spacing">
                <div class="ticket-type-item" :class="{ select: chooseIndex == 1 }" @click="clickChoose2(1)">
                    <img
                        class="status-img"
                        :src="
                            require(chooseIndex == 1
                                ? '@/assets/icons/icon-choose.png'
                                : '@/assets/icons/icon-unchoose.png')
                        "
                    />
                    <div class="line">
                        <div class="name">优惠券购票</div>
                        <div class="price">
                            <span class="text">¥{{ detail.useCardUnitPrice }}/张</span>
                        </div>
                    </div>
                    <div class="tip">
                        <div class="line">出票时间在15~50分钟</div>
                    </div>
                    <div class="coupon-box" @click.stop="toSelectCoupon">
                        <div class="coupon-title">
                            <div class="text">优惠券</div>
                            <div class="bg"></div>
                        </div>
                        <div class="coupon-text" v-if="detail.cardCodes.length > 0">
                            已用{{ detail.cardCodes.length }}张优惠券，立减￥{{ detail.cardDiscountAmount }}
                        </div>
                        <div class="coupon-text" v-else>
                            {{ hasUseCoupon ? '请选择优惠券' : '暂无优惠券' }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="ticket-type-box" v-else-if="isShowSwitchDrawMode">
            <div
                class="ticket-type-item"
                v-if="$store.state.common.config.enableDiscount && !$store.state.common.config.enableAuction"
                :class="{ 'no-select': !status.preferential }"
                @click="clickChoose(0, status.preferential)"
            >
                <img
                    class="status-img"
                    :src="
                        require(chooseIndex == 0
                            ? '@/assets/icons/icon-choose.png'
                            : '@/assets/icons/icon-unchoose.png')
                    "
                />
                <div class="line">
                    <div class="name">特惠购票</div>
                    <div class="price">
                        <span class="text">¥{{ qzPrice || '--.--' }}</span>
                        <!-- <span class="company">/张</span> -->
                    </div>
                </div>
                <div class="line j-s">
                    <div class="characteristic">提前订票</div>
                    <div class="characteristic">更加优惠</div>
                    <div class="characteristic">出票成功率95%</div>
                </div>
                <div class="line line-change-refund" @click.stop="showAgreement(3)">
                    <div class="change-refund-item no">不支持限时退票</div>
                    <div class="change-refund-item no">不支持限时改签</div>
                    <div class="change-refund-more">退改须知</div>
                </div>
            </div>
            <div
                class="ticket-type-item"
                v-if="$store.state.common.config.enableFastDrawMode"
                :class="{ 'no-select': !status.directPurchase }"
                @click="clickChoose(1, status.directPurchase)"
            >
                <img
                    class="status-img"
                    :src="
                        require(chooseIndex == 1
                            ? '@/assets/icons/icon-choose.png'
                            : '@/assets/icons/icon-unchoose.png')
                    "
                />
                <div class="line">
                    <div class="name">极速出票</div>
                    <div class="price">
                        <span class="text">¥{{ qmmPrice }}</span>
                        <!-- <span class="company">/张</span> -->
                    </div>
                </div>
                <div class="line j-s">
                    <div class="characteristic">实时出票</div>
                    <div class="characteristic">临场可买</div>
                    <div class="characteristic">{{ fastDrawTime }}分钟未出退款</div>
                </div>
                <div class="line line-change-refund" @click.stop="showAgreement(1)">
                    <div class="change-refund-item ok">支持限时退票</div>
                    <div class="change-refund-item no">不支持限时改签</div>
                    <div class="change-refund-more">退改须知</div>
                </div>
            </div>
            <div
                class="ticket-type-item"
                v-if="$store.state.common.config.enableAuction"
                :class="{ 'no-select': !status.biddingPurchase }"
                @click="clickChoose(2, status.biddingPurchase)"
            >
                <img
                    class="status-img"
                    :src="
                        require(chooseIndex == 2
                            ? '@/assets/icons/icon-choose.png'
                            : '@/assets/icons/icon-unchoose.png')
                    "
                />
                <div class="line">
                    <div class="name doubt" @click.stop="doubt">询价比价购票</div>
                </div>
                <div class="line j-s">
                    <div class="characteristic">自动全网比价查询当前优惠价格，价格满意再付款</div>
                </div>
                <div class="line line-change-refund" @click.stop="showAgreement(3)">
                    <div class="change-refund-item no">不支持限时退票</div>
                    <div class="change-refund-item no">不支持限时改签</div>
                    <div class="change-refund-more">退改须知</div>
                </div>
            </div>
        </div>
        <div class="ticket-type-box" v-else-if="$store.state.common.config.enableFastDrawMode">
            <div class="ticket-type-item">
                <div class="line line-change-refund" @click.stop="showAgreement(1)">
                    <div class="change-refund-item ok">支持限时退票</div>
                    <div class="change-refund-item no">不支持限时改签</div>
                    <div class="change-refund-more">退改须知</div>
                </div>
            </div>
        </div>
        <div class="ticket-type-box" v-else-if="$store.state.common.config.enableDiscount">
            <div class="ticket-type-item">
                <div class="line line-change-refund" @click.stop="showAgreement(3)">
                    <div class="change-refund-item no">不支持限时退票</div>
                    <div class="change-refund-item no">不支持限时改签</div>
                    <div class="change-refund-more">退改须知</div>
                </div>
            </div>
        </div>
        <div class="model">
            <div class="line coupon" v-if="!(detail.cardAddPoint > 0)">
                <div class="line-title">优惠券</div>
                <div class="coupon-info" @click="toSelectCoupon">
                    <div class="no-coupon" v-if="!detail.cardDiscountAmount">
                        {{ hasUseCoupon ? '请选择优惠券' : '暂无优惠券' }}
                    </div>
                    <div class="has-coupon" v-else>-{{ detail.cardDiscountAmount }}元</div>
                </div>
                <div class="icon-right"></div>
            </div>
            <div class="line price-box" v-if="!(detail.cardAddPoint > 0)">
                <div class="line-title">
                    <div class="original-price" :class="{ 'line-through': (saveAmount || 0) > 0 }">
                        原价¥{{ totalMarketPrice }}
                    </div>
                    <div class="save-amount" v-if="(saveAmount || 0) > 0">立省¥{{ saveAmount || 0 }}</div>
                </div>
                <div class="line-value">
                    <div class="subtotal">共{{ detail.seatsCount }}张,票价合计:</div>
                    <div class="amount">¥{{ detail.totalPrice }}</div>
                </div>
            </div>
            <div class="line mobile">
                <div class="line-title">手机号</div>
                <div class="mobile-tip">接收出票短信提醒</div>
                <div class="line-value">
                    <input class="input" maxlength="11" type="number" placeholder="必填" v-model="userMobile" />
                </div>
            </div>
        </div>
        <div class="model">
            <div class="line notice">
                <div class="line-title bold">购票须知</div>
                <div class="line-value secondary" @click="checkRead">
                    <img
                        class="section-img"
                        :src="
                            require(payAgree
                                ? '@/assets/icons/icon-choose.32.png'
                                : '@/assets/icons/icon-unchoose.32.png')
                        "
                    />
                    <div class="text">{{ payAgree ? '已读' : '未读' }}</div>
                </div>
            </div>
            <div class="section-content" v-if="!isShowSwitchDrawMode && status.directPurchase">
                <div>
                    <span>
                        1.请确认场次和时间无误，购买成功后将
                        <span class="keynote">不予退换</span>
                        。
                    </span>
                </div>
                <div>
                    <span>
                        2.出票时间为0-16分钟，由于系统波动，场次调整等因素，存在出票失败的情况，出单失败后会在20分钟内原路退回，到账时间以付款平台规则为准。
                    </span>
                </div>
                <div>
                    <span>3.出票成功后请在我的订单中查看取票码，到对应</span>
                    <span class="keynote">影院自助机取票和影院前台</span>
                    <span>取票。</span>
                </div>
                <div>
                    <span>4.如遇问题请尽快联系下单页面客服咨询解决（9:00-23:00）。</span>
                </div>
            </div>
            <div class="section-content" v-else>
                <div>
                    <span>1.</span>
                    <span class="keynote">支付前务必确认影院、影片、场次准确无误。</span>
                </div>
                <template v-if="$store.getters.getExposeMethod.hideTicketMethod">
                    <div>
                        <span>2.出票成功后请在我的订单中查看取票码，到对应</span>
                        <span class="keynote">影院自助机取票和影院前台</span>
                        <span>取票。</span>
                    </div>
                    <div>
                        <span v-if="!$store.getters.getExposeMethod.customerServiceMobileTip">
                            3.如遇问题请尽快联系页面客服咨询解决。
                        </span>
                        <span v-else>
                            3.如遇问题请尽快联系通联支付客服电话
                            <a href="tel:95193">95193</a>
                        </span>
                    </div>
                </template>
                <template v-else>
                    <div>
                        <span>2.因各影院取票系统存在差异，</span>
                        <span class="keynote">纸质票显示票价与在线购票展示价格不一致</span>
                        <span>，以您在线购票结算页面展示的价格为准。</span>
                    </div>
                    <div>
                        <span>
                            3.用户根据观影安排执行选择购票类型与方式，并仔细阅读本平台公示的相关退票、改签服务内容。
                        </span>
                    </div>
                    <div>
                        <span>
                            4.
                            <span class="keynote">如已经在影院取票或过了放映时间的，那么也将不支持退票。</span>
                        </span>
                    </div>
                    <div>
                        <span>5.出票是由平台入驻的商家提供影票代购服务，若出票失败，将会在两小时内自动退款。</span>
                        <span class="keynote">夜间22:00~次日早9:00，不在两小时自动退款范国内。</span>
                        <span>夜间未出票订单最迟将在次日11:00退回。</span>
                    </div>
                    <div>
                        <span>6.出票成功后，</span>
                        <span class="keynote">在所选影院的自助取票或者前台取票即可</span>
                        <span>。若无法取票，</span>
                        <span class="keynote">请联系在线客服协助处理。</span>
                    </div>
                    <div>
                        <span>7.如需带儿童观影，请咨询影院是否需要单独购票。</span>
                    </div>
                    <div>
                        <span>8.手续费按照订单内座位张数进行计算。</span>
                    </div>
                    <div>
                        <span v-if="!$store.getters.getExposeMethod.customerServiceMobileTip">
                            9.如有其他疑问，请联系平台客服。
                        </span>
                        <span v-else>
                            9.如遇问题请尽快联系通联支付客服电话
                            <a href="tel:95193">95193</a>
                        </span>
                    </div>
                </template>
            </div>
        </div>
        <div class="model">
            <div>购买阈值：每个用户每日限购4次，每月限购15次。</div>
            <div>退票阈值：极速出票仅支持每个用户每日允许退款1次，每月允许退款3次。</div>
        </div>
        <div class="popup" v-if="showPopupStatus" @click="hideTip">
            <div class="tip-message iphone-x-adaptation" @click.stop="">
                <div class="title">退改签须知</div>
                <div class="content">
                    <p class="bold">关于退票：</p>
                    <p>
                        排队中的订单，您可以在首页电影-订单-点击进入后，自行申请取消订单，完成取消后我们将原路退回您的款项；出单中和已出票的订单不支持退票。
                    </p>
                    <p class="bold">关于改签：</p>
                    <p>
                        排队中的订单，您可以在首页电影-订单-点击进入后，自行申请取消订单，完成取消后我们将原路退回您的款项；出单中和已出票的订单不支持改签。
                    </p>
                </div>
                <div class="iphone-x-adaptation-padding iphone-x-adaptation"></div>
                <img class="close" src="~@/assets/icons/icon-close.png" @click="hideTip" />
            </div>
        </div>
        <div class="dialog" v-if="showAgreementStatus" @click="hideDialog">
            <div class="dialog-agreement" @click.stop="">
                <div class="title">退改签须知</div>
                <div class="content">
                    <template v-if="showAgreementMode == 1 || showAgreementMode == 2">
                        <div class="content-title ok">支持限时退票</div>
                        <div class="content-line">未取票,且距开场前2小时内,不支持退票</div>
                        <div class="content-line">未取票,且距开场前2~36小时内,收取退票服务费90%</div>
                        <div class="content-line">未取票,且距开场前36~72小时内,收取退票服务费50%</div>
                        <div class="content-line">未取票,且距开场前72小时以上,收取退票服务费0%</div>
                        <div class="content-title no">不支持限时改签</div>
                        <div class="content-line">本影院不支持改签</div>
                    </template>
                    <template v-else-if="showAgreementMode == 3 || showAgreementMode == 4">
                        <div class="content-title no">不支持限时退票</div>
                        <div class="content-line">本影院不支持改签</div>
                        <div class="content-title no">不支持限时改签</div>
                        <div class="content-line">本影院不支持改签</div>
                    </template>
                    <template v-if="showAgreementMode == 1">
                        <div class="content-title">特别提醒</div>
                        <div class="content-line">每个用户每日允许退款1次,每月允许退款3次。</div>
                        <div class="content-line">仅限整单退改签,不支持分座位退改签</div>
                        <div class="content-line">
                            点击查看完整版
                            <span class="agreement" @click="toAgreement">《退改签协议》</span>
                        </div>
                    </template>
                    <template v-else-if="showAgreementMode == 2">
                        <div class="content-line top-40">因影院规定要求，不支持退改签</div>
                        <div class="content-line">
                            点击查看完整版
                            <span class="agreement" @click="toAgreement">《退改签协议》</span>
                        </div>
                    </template>
                    <template v-else-if="showAgreementMode == 3">
                        <div class="content-title">特别提醒</div>
                        <div class="content-line">因影院规定要求，不支持退改签</div>
                        <div class="content-line">
                            点击查看完整版
                            <span class="agreement" @click="toAgreement">《退改签协议》</span>
                        </div>
                    </template>
                    <template v-else-if="showAgreementMode == 4">
                        <div class="content-line top-40">因影院规定要求，不支持退改签</div>
                        <div class="content-line">
                            点击查看完整版
                            <span class="agreement" @click="toAgreement">《退改签协议》</span>
                        </div>
                    </template>
                    <template v-if="showAgreementMode == 1 || showAgreementMode == 3">
                        <div class="btn btn-agree ok" @click="hideDialog">我知道了</div>
                    </template>
                    <template v-else-if="showAgreementMode == 2 || showAgreementMode == 4">
                        <div class="line-agree" :class="{ ok: payAgree }" @click="payAgree = !payAgree">
                            <div class="value">我已阅读并同意以上协议及退改签须知与购票须知</div>
                        </div>
                        <div class="btn btn-agree" :class="{ ok: payAgree }" @click="payAgree && submit()">
                            继续购票
                        </div>
                        <div class="btn btn-no" @click="hideDialog">暂不购票</div>
                    </template>

                    <!-- <div
                        class="btn btn-agree"
                        :class="{ ok: payAgree }"
                        @click="payAgree && submit()"
                    >
                        继续购票
                    </div> -->
                </div>
            </div>
        </div>
        <div class="footer-occupy iphone-x-adaptation"></div>
        <div class="footer iphone-x-adaptation">
            <div class="box">
                <div>
                    <div v-if="detail.cardAddPoint > 0">
                        <span>实际付款：</span>
                        <span class="money">¥{{ cardAddPointTotal }}</span>
                    </div>
                    <div v-else-if="chooseIndex == 2">
                        <span>等待官方竞价：</span>
                        <span class="money">¥{{ biddingPredictPrice }}</span>
                    </div>
                    <div v-else>
                        <span>实际付款：</span>
                        <span class="money">¥{{ detail.totalPrice }}</span>
                    </div>
                    <div class="flex filme-another" v-if="detail.platformShowOptions">
                        <div class="filme-commission" v-for="(item, index) in detail.platformShowOptions" :key="index">
                            <span>
                                {{ item.key }}
                                <span class="filme-commission-num">{{ item.value }}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="btn" @click="nextShowAgreement()">
                    <span v-if="chooseIndex == 2">提交订单</span>
                    <span v-else>
                        {{ $store.getters.getExposeMethod.expandName == 'FuDuDu' ? '积分付款' : '立即付款' }}
                    </span>
                </div>
            </div>
        </div>
        <div class="accept-adjust-dialog" v-if="acceptAdjustDialogStatus" @click="acceptAdjustDialogStatus = false">
            <div class="content" @click.stop="">
                <div class="header"></div>
                <div class="message">
                    <p>若您所选座位被他人占座时</p>
                    <p style="color: rgba(217, 2, 9, 1)">系统自动匹配剩余座位最佳观影区</p>
                </div>
                <div class="btn-list">
                    <div class="btn-item" @click="setAcceptAdjustStatus(false)">
                        <p>不调座</p>
                        <p>占座失败自动退款</p>
                    </div>
                    <div class="btn-item agree" @click="setAcceptAdjustStatus(true)">
                        <p>同意调座</p>
                        <p>多张票保证连座</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    GET_ORDER_INFO,
    UPDATE_ORDER_USER_MOBILE,
    GET_ORDER_INFO_FOR_ORDER_NO,
    SUBMIT_0_ORDER,
    GET_AVAILABLE_COUPON_LIST,
    GET_QMM_PRICE,
    UPDATE_ORDER_ACCEPT_ADJUST,
    UPDATE_ORDER_DRAW_MODE,
    SUBMIT_BID_ORDER,
    CANCEL_USE_MOVIE_COUPON,
} from 'api';
import { PAGE_COUPON_SELECT, PAGE_ORDER_INFO, PAGE_ORDER_BID, PAGE_AGREEMENT_REFUND } from 'page';
import moment from 'moment';
import pay from 'pay';
import number from '@/lib/number';
export default {
    data() {
        return {
            id: 0,
            orderNo: '',

            chooseIndex: -1,
            status: {
                preferential: !true,
                directPurchase: true,
                biddingPurchase: !true,
            },
            qzPrice: '--.--',
            qmmPrice: '--.--',

            detail: {},
            message: '',
            payAgree: false,
            userMobile: '',
            showPopupStatus: false,
            showAgreementStatus: false,
            showAgreementMode: 0, // 1:快票查看 2:2快票确认 3:慢票查看 4:慢票确认
            agreementBtnStatus: false,
            hasUseCoupon: false,
            acceptAdjust: false,
            acceptAdjustDialogStatus: false,

            // 原价总价值
            totalMarketPrice: 0,
            totalPrice: '--.--',
            saveAmount: 0,
        };
    },
    computed: {
        isShowSwitchDrawMode() {
            // 判断 快速 、 折扣 和 竞价 模式中是否有两个以上开启
            return (
                this.$store.state.common.config.enableAuction +
                    this.$store.state.common.config.enableFastDrawMode +
                    this.$store.state.common.config.enableDiscount >
                1
            );
        },
        fastDrawTime() {
            let _fastDrawTime = 16;
            if (this.$store.state.common.config.fastDrawModeVersion == 1) {
                _fastDrawTime = 16;
            } else if (this.$store.state.common.config.fastDrawModeVersion == 2) {
                _fastDrawTime = 30;
            }
            return _fastDrawTime;
        },
        biddingPredictPrice() {
            let minPrice = 0;
            let maxPrice = 0;
            for (let i = 0; i < this.detail.seats.length; i++) {
                const item = this.detail.seats[i];
                let tempMinPrice = Math.round(number.operation(`${item.fastDrawModePrice}*${0.2}`) * 10) / 10;
                let tempMaxPrice = Math.round(number.operation(`${item.fastDrawModePrice}*${0.8}`) * 10) / 10;
                minPrice = number.operation(`${minPrice}+${tempMinPrice}`);
                maxPrice = number.operation(`${maxPrice}+${tempMaxPrice}`);
            }
            return `${+minPrice}~${+maxPrice}`;
        },
        cardAddPointTotal() {
            return {
                0: this.detail.notUseCardUnitPrice * this.detail.seatsCount,
                1: this.detail.totalPrice,
            }[this.chooseIndex];
        },
    },
    watch: {
        showPopupStatus(val) {
            if (val) {
                this.$util.lockScreen();
            } else {
                this.$util.unlockScreen();
            }
        },
    },
    created() {
        this.id = this.$route.query.orderId;
        this.orderNo = this.$route.query.orderNo;
        this.ecm = JSON.parse(this.$route.query.ecm);
        this.efdm = JSON.parse(this.$route.query.efdm);
        this.eam = JSON.parse(this.$route.query.eam);
        this.getMovieInfo();
        this.getCanUseCoupon();
        this.getQMMprice();
    },
    methods: {
        getMovieInfo() {
            if (this.orderNo) {
                this.$util
                    .get(GET_ORDER_INFO_FOR_ORDER_NO, {
                        orderNo: this.orderNo,
                    })
                    .then(res => {
                        this.orderInfoResNext(res);
                    });
            } else if (this.id) {
                this.$util.get(`${GET_ORDER_INFO}/${this.id}`).then(res => {
                    this.orderInfoResNext(res);
                });
            }
        },
        getCanUseCoupon() {
            this.$util
                .post(GET_AVAILABLE_COUPON_LIST, {
                    orderNo: this.orderNo,
                })
                .then(res => {
                    if (res.success && res.data.available.length > 0) {
                        this.hasUseCoupon = true;
                    } else {
                        this.hasUseCoupon = false;
                    }
                });
        },
        orderInfoResNext(res) {
            if (res.success) {
                // 设置购票方式 start
                if (!this.ecm) {
                    this.status.preferential = false;
                } else {
                    this.status.preferential = true;
                }
                if (!this.efdm) {
                    this.status.directPurchase = false;
                } else {
                    this.status.directPurchase = true;
                }
                if (!this.eam) {
                    this.status.biddingPurchase = false;
                } else {
                    this.status.biddingPurchase = true;
                }

                // if (this.status.preferential && this.status.directPurchase) {
                //     this.chooseIndex = res.data.drawMode == 0 ? 0 : 1;
                // }
                // if (this.status.biddingPurchase && this.status.preferential) {
                //     this.chooseIndex = 2;
                // } else if (this.status.preferential) {
                //     this.chooseIndex = 0;
                // } else if (this.status.directPurchase) {
                //     this.chooseIndex = 1;
                // }

                if (res.data.drawMode == 0 && res.data.auction) {
                    this.chooseIndex = 2;
                } else if (res.data.drawMode == 0) {
                    this.chooseIndex = 0;
                } else if (res.data.drawMode == 5) {
                    this.chooseIndex = 1;
                }

                if (this.chooseIndex == 0) {
                    this.totalPrice = res.data.totalPrice;
                } else if (this.chooseIndex == 1) {
                    this.totalPrice = number.operation(`${res.data.seatsCount}*${res.data.marketUnitPrice}`);
                }

                if (res.data.cardAddPoint > 0) {
                    if (res.data.cardDiscountAmount > 0) {
                        this.chooseIndex = 1;
                    } else {
                        this.chooseIndex = 0;
                    }
                }

                // 设置购票方式 end
                // 凭借电影信息说明 start
                res.data.movieInformation =
                    moment(res.data.showTime).format('M月D日 HH:mm') + ' ' + res.data.versionTypes;
                // 凭借电影信息说明 end
                // 是否同意调座
                this.acceptAdjust = res.data.acceptAdjust;
                this.detail = res.data;
                this.userMobile = this.detail.userMobile;
                this.totalMarketPrice = +number.operation(`${res.data.marketUnitPrice}*${res.data.seatsCount}`);
                this.saveAmount = this.detail.saveAmount;
            }
        },
        checkRead() {
            this.payAgree = !this.payAgree;
        },
        toGuide() {
            window.open(`${window.location.origin}/zhengce/zhengceku/2020-07/16/content_5527363.html`);
        },
        showTip() {
            this.showPopupStatus = true;
        },
        hideTip() {
            this.showPopupStatus = false;
        },
        nextShowAgreement() {
            this.showAgreement({ 0: 4, 1: 2, 2: 4 }[this.chooseIndex]);
        },
        showAgreement(mode) {
            this.showAgreementStatus = true;
            this.showAgreementMode = mode;
        },
        hideDialog() {
            this.showAgreementStatus = false;
        },
        toSelectCoupon() {
            this.$util.pageJump(PAGE_COUPON_SELECT, {
                orderNo: this.orderNo,
                seatsCount: this.detail.seatsCount,
            });
        },
        // 切换是否接受调座位
        switchAcceptAdjust() {
            if (this.acceptAdjust) {
                this.acceptAdjustDialogStatus = true;
            } else {
                this.acceptAdjust = !this.acceptAdjust;
            }
        },
        clickChoose2(index) {
            this.chooseIndex = index;
        },
        // 切换模式
        async clickChoose(index, status) {
            if (!status && index == 0) {
                this.showEcmToast();
                return;
            } else if (!status) {
                return;
            }
            this.chooseIndex = index;
            let tempDrawMode = { 0: 0, 1: 5, 2: 0 }[index];
            await this.$util.post(UPDATE_ORDER_DRAW_MODE, {
                orderNo: this.detail.orderNo,
                drawMode: tempDrawMode,
            });
            this.getMovieInfo();
        },
        // 拉去趣满满价格
        getQMMprice() {
            this.$util
                .post(GET_QMM_PRICE, {
                    orderNo: this.orderNo,
                })
                .then(res => {
                    if (res.success) {
                        this.qmmPrice = res.data.settlePrice;
                        this.qzPrice = res.data.selfPrice;
                    }
                });
        },
        doubt() {
            this.$toast('底价折扣票数量有限，询价后价格满意请即时支付，否则将无法再次询价哦~');
        },
        showEcmToast() {
            if (this.detail.disableCompetitionModeType == 1 && this.stopSellMinuteOfSelfText) {
                this.$toast(
                    `特惠抢票，请最少提前${this.$store.state.common.config.stopSellMinuteOfSelfText}！！！`,
                    3000
                );
            } else if (this.detail.disableCompetitionModeType == 2) {
                this.$toast(
                    `特惠票已抢光，非精品影院每${this.detail.competitionModeReleaseInterval}分钟释放一批折扣票，建议选择精品影院购票。`,
                    3000
                );
            }
        },
        // 设置调座状态
        setAcceptAdjustStatus(status) {
            this.acceptAdjust = status;
            this.acceptAdjustDialogStatus = false;
        },
        submit() {
            // if (!this.payAgree) {
            //     this.showAgreementStatus = true;
            //     return;
            // }
            this.showAgreementStatus = false;
            if (!this.userMobile || this.userMobile.length != 11) {
                this.$toast('请填写正确的手机号');
                return;
            }
            let requestList = [];
            // 验证手机号 是否需要修改
            if (this.userMobile != this.detail.userMobile) {
                requestList.push(() =>
                    this.$util.post(UPDATE_ORDER_USER_MOBILE, {
                        orderNo: this.detail.orderNo,
                        userMobile: this.userMobile,
                    })
                );
            }
            // 验证是否调整同意调座
            if (this.acceptAdjust != this.detail.acceptAdjust) {
                requestList.push(() =>
                    this.$util.post(UPDATE_ORDER_ACCEPT_ADJUST, {
                        orderNo: this.detail.orderNo,
                        acceptAdjust: this.acceptAdjust,
                    })
                );
            }
            // 判断是否要取消使用优惠券
            if (this.detail.cardAddPoint > 0) {
                if (this.chooseIndex == 0 && this.detail.cardCodes.length > 0) {
                    requestList.push(() =>
                        this.$util.post(CANCEL_USE_MOVIE_COUPON, {
                            orderNo: this.detail.orderNo,
                        })
                    );
                }
            }

            Promise.all(requestList.map(v => v())).then(([...promiseResList]) => {
                for (let i = 0; i < promiseResList.length; i++) {
                    const promiseResItem = promiseResList[i];
                    if (!promiseResItem.success) {
                        return;
                    }
                }
                if (this.chooseIndex == 2) {
                    this.submitBidOrder();
                } else {
                    this.payNext();
                }
            });
        },
        submitBidOrder() {
            this.$util.post(`${SUBMIT_BID_ORDER}?orderNo=${this.detail.orderNo}`).then(res => {
                if (res.success) {
                    this.$util.pageJump({
                        path: PAGE_ORDER_BID,
                        query: {
                            orderNo: this.detail.orderNo,
                        },
                        config: {
                            jumpType: 1,
                        },
                    });
                }
            });
        },
        payNext() {
            if (this.detail.totalPrice == 0) {
                this.$util
                    .post(SUBMIT_0_ORDER, {
                        orderNo: this.detail.orderNo,
                    })
                    .then(res => {
                        this.$util.pageJump(PAGE_ORDER_INFO, {
                            orderNo: this.detail.orderNo,
                        });
                    });
            } else {
                pay({
                    orderType: 5,
                    orderId: this.detail.id,
                    orderNo: this.detail.orderNo,
                }).then(payRes => {
                    if (payRes.success) {
                    } else {
                        this.$toast(payRes.message);
                    }
                });
            }
        },
        toAgreement() {
            this.$util.pageJump(PAGE_AGREEMENT_REFUND);
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
@footerHeight: .pxToRem(100) [];
.pay {
    width: 100%;
    min-height: 100vh;
    padding-bottom: calc(@footerHeight + .pxToRem(20) []);
    box-sizing: border-box;

    .order-info {
        background: white;
        margin: .pxToRem(20) [] .pxToRem(30) [] .pxToRem(0) [];
        border-radius: .pxToRem(40) [];
        .session-info {
            display: flex;
            padding: .pxToRem(40) [] .pxToRem(30) [] .pxToRem(30) [] .pxToRem(30) [];
            .order-item-img {
                width: .pxToRem(160) [];
                height: .pxToRem(210) [];
                border-radius: .pxToRem(16) [];
                overflow: hidden;
                .img {
                    width: 100%;
                    height: 100%;
                }
            }
            .order-item-content {
                flex: 1;
                margin-left: .pxToRem(30) [];
                .film-name {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(40) [];
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.9);
                    margin-bottom: .pxToRem(12) [];
                }
                .time,
                .cinema-name,
                .hall-name {
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    color: rgba(0, 0, 0, 0.9);
                }
                .seat-list {
                    margin-top: .pxToRem(12) [];
                    .seat-item {
                        display: inline-block;
                        padding: .pxToRem(4) [] .pxToRem(12) [];
                        border: .pxToRem(1) [] solid #313131;
                        line-height: .pxToRem(36) [];
                        font-size: .pxToRem(24) [];
                        color: rgba(0, 0, 0, 0.9);
                        border-radius: .pxToRem(8) [];
                        margin-right: .pxToRem(8) [];
                        margin-bottom: .pxToRem(8) [];
                    }
                }
            }
        }
        .dividing-line {
            height: .pxToRem(40) [];
            .line-item {
                .base-center;
                width: .pxToRem(630) [];
                height: .pxToRem(1) [];
                background: rgba(0, 0, 0, 0.15);
            }
            &::before {
                content: ' ';
                .base-center-y;
                left: 0;
                height: .pxToRem(36) [];
                width: .pxToRem(18) [];
                background: #f5f5f5;
                border-top-right-radius: .pxToRem(18) [];
                border-bottom-right-radius: .pxToRem(18) [];
            }
            &::after {
                content: ' ';
                .base-center-y;
                right: 0;
                height: .pxToRem(36) [];
                width: .pxToRem(18) [];
                background: #f5f5f5;
                border-top-left-radius: .pxToRem(18) [];
                border-bottom-left-radius: .pxToRem(18) [];
            }
        }
        .tip-list {
            display: flex;
            padding: .pxToRem(0) [] .pxToRem(64) [] .pxToRem(14) [] .pxToRem(30) [];
            height: .pxToRem(76) [];
            line-height: .pxToRem(76) [];
            justify-content: space-between;
            align-items: center;
            .tip-item {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #3c3c3c;
                font-size: .pxToRem(28) [];
                img {
                    .sq(32);
                }
                span {
                    margin-left: .pxToRem(10) [];
                }
                &:last-child {
                    color: #666666;
                }
            }
            &:before {
                content: ' ';
                position: absolute;
                top: .pxToRem(26) [];
                right: .pxToRem(30) [];
                .sq(24);
                background: url(~@/assets/icons/icon-right.png);
                background-size: cover;
            }
        }
    }

    .model {
        margin: .pxToRem(20) [] .pxToRem(30) [] .pxToRem(0) [];
        margin-top: .pxToRem(20) [];
        box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] .pxToRem(0) [] rgba(0, 0, 0, 0.08);
        padding: .pxToRem(23) [] .pxToRem(30) [];
        border-radius: .pxToRem(30) [];
        background: white;
        .line {
            display: flex;
            justify-content: space-between;
            padding: .pxToRem(20) [] 0;
            height: .pxToRem(54) [];
            line-height: .pxToRem(54) [];
            .line-title {
                font-size: .pxToRem(28) [];
                color: rgba(0, 0, 0, 0.9);
                white-space: nowrap;
            }
            .line-value {
                display: flex;
                font-size: .pxToRem(30) [];
            }
            &.coupon {
                align-items: center;
                .line-title {
                    flex: 1;
                }
                .coupon-info {
                    .no-coupon {
                        margin-right: .pxToRem(20) [];
                        font-size: .pxToRem(28) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.5);
                        line-height: .pxToRem(44) [];
                    }
                    .has-coupon {
                        height: .pxToRem(44) [];
                        line-height: .pxToRem(44) [];
                        padding: 0 .pxToRem(30) [] 0 .pxToRem(70) [];
                        background: url('~@/assets/icons/icon-card-yellow.png') rgba(0, 0, 0, 0.9);
                        background-repeat: no-repeat;
                        background-size: .pxToRem(32) [] .pxToRem(32) [];
                        background-position: center left .pxToRem(30) [];
                        border-radius: .pxToRem(22) [];
                        font-size: .pxToRem(28) [];
                        font-weight: 400;
                        color: #f8c32f;
                        line-height: .pxToRem(44) [];
                    }
                }
                .icon-right {
                    .sq(32);
                    background: url('~@/assets/icons/icon-right.png');
                    background-size: cover;
                }
            }
            &.price-box {
                .line-title {
                    display: flex;
                    .original-price {
                        font-size: .pxToRem(28) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.5);
                        margin-right: .pxToRem(14) [];
                        &.line-through {
                            text-decoration: line-through;
                        }
                    }
                    .save-amount {
                        font-size: .pxToRem(28) [];
                        font-weight: 600;
                        color: #f7b500;
                    }
                }
                .line-value {
                    .subtotal {
                        font-size: .pxToRem(28) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.5);
                    }
                    .amount {
                        font-size: .pxToRem(30) [];
                        font-weight: 600;
                        color: #d80108;
                    }
                }
            }
            &.mobile {
                .line-value {
                    .input {
                        text-align: right;
                        background: rgba(0, 0, 0, 0);
                    }
                }
            }
            &.notice {
                .line-value {
                    align-items: center;
                    .section-img {
                        .sq(32);
                        margin-right: .pxToRem(16) [];
                    }
                }
            }
            & + .line {
                &::before {
                    content: ' ';
                    position: absolute;
                    top: 0;
                    left: .pxToRem(0) [];
                    right: .pxToRem(0) [];
                    height: .pxToRem(1) [];
                    border-radius: .pxToRem(1) [];
                    background: rgba(0, 0, 0, 0.15);
                }
            }
        }
        .mobile-tip {
            flex: 1;
            margin-left: .pxToRem(10) [];
            font-size: .pxToRem(22) [];
            color: rgba(0, 0, 0, 0.4);
        }
        &.seat {
            padding: .pxToRem(30) [];
            .line {
                height: .pxToRem(44) [];
                line-height: .pxToRem(44) [];
                .line-title {
                    font-size: .pxToRem(28) [];
                    color: rgba(0, 0, 0, 0.9);
                }
                .line-value {
                    font-size: .pxToRem(28) [];
                    color: rgba(0, 0, 0, 0.5);
                }
            }
            .accept-adjust-box {
                margin-top: .pxToRem(44) [];
                .accept-adjust-title {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(30) [];
                    font-weight: 600;
                    color: rgba(0, 0, 0, 0.9);
                }
                .accept-adjust-tip {
                    margin-top: .pxToRem(10) [];
                    line-height: .pxToRem(38) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.5);
                }
                .status {
                    position: absolute;
                    top: .pxToRem(-4) [];
                    right: 0;
                    width: .pxToRem(80) [];
                    height: .pxToRem(48) [];
                    border-radius: .pxToRem(36) [];
                    // background: @theme_color_first;
                    background: #f0f0f0;
                    box-sizing: border-box;

                    &::after {
                        content: ' ';
                        .base-center-y;
                        right: .pxToRem(34) [];
                        .sq(43);
                        background: white;
                        border-radius: 100%;
                        transition: all 0.3s;
                    }
                    &.accept-adjust {
                        background: @theme_color_first;
                        &::after {
                            right: .pxToRem(3) [];
                        }
                    }
                }
            }
        }
    }

    .ticket-type-box {
        margin-top: .pxToRem(20) [];
        margin-left: .pxToRem(30) [];
        margin-right: .pxToRem(30) [];
        box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
        border-radius: .pxToRem(40) [];
        background: white;
        .title {
            padding: .pxToRem(20) [] .pxToRem(30) [];
            font-size: .pxToRem(28) [];
            font-weight: bold;
            color: rgba(0, 0, 0, 0.9);
            line-height: .pxToRem(40) [];
        }
        .ticket-type-item {
            padding: .pxToRem(30) [] .pxToRem(30) [];
            border: 1px solid rgba(0, 0, 0, 0);
            .status-img {
                position: absolute;
                top: .pxToRem(30) [];
                right: .pxToRem(22) [];
                width: .pxToRem(44) [];
                height: .pxToRem(44) [];
            }
            .tip-51 {
                margin-top: .pxToRem(20) [];
                margin-bottom: .pxToRem(-20) [];
                font-weight: bold;
                color: #d90209;
            }
            .tip {
                margin-top: .pxToRem(30) [];
                // padding-right: .pxToRem(60) [];
                .line {
                    display: block;
                    line-height: .pxToRem(36) [];
                    color: rgba(0, 0, 0, 0.5);
                    font-size: .pxToRem(24) [];
                    transition: all 0.3s;
                }
                &:not(.open) {
                    .line + .line {
                        display: none;
                    }
                }

                .more-show {
                    position: absolute;
                    top: 0;
                    right: 0;
                    .sq(32);
                    background: url('~@/assets/icons/icon-down-32x32.png');
                    background-size: contain;
                    transition: all 0.3s;
                }
                &.open {
                    .more-show {
                        transform: rotate(180deg);
                    }
                }
            }
            .line {
                .text {
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.6);
                }
                .name {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(30) [];
                    color: rgba(0, 0, 0, 0.9);
                    &.doubt {
                        &:before {
                            position: absolute;
                            right: .pxToRem(-48) [];
                            top: 50%;
                            transform: translateY(-50%);
                            content: ' ';
                            width: .pxToRem(32) [];
                            height: .pxToRem(32) [];
                            background: url('~@/assets/icons/icon-doubt.png');
                            background-size: contain;
                        }
                    }
                }
                .price {
                    margin-left: .pxToRem(36) [];
                    margin-right: .pxToRem(56) [];
                    // font-size: .pxToRem(22) [];
                    color: rgba(0, 0, 0, 0.3);
                    .text {
                        font-size: .pxToRem(26) [];
                        line-height: .pxToRem(36) [];
                        margin-right: .pxToRem(8) [];
                    }
                    .company {
                        line-height: .pxToRem(32) [];
                        font-size: .pxToRem(22) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.3);
                    }
                }
                .characteristic {
                    margin-top: .pxToRem(15) [];
                    margin-right: .pxToRem(10) [];
                    padding: 0 .pxToRem(16) [];
                    box-sizing: border-box;
                    height: .pxToRem(34) [];
                    line-height: .pxToRem(34) [];
                    border: .pxToRem(2) [] solid rgba(0, 0, 0, 1);
                    border-radius: .pxToRem(8) [];
                    font-size: .pxToRem(20) [];
                    &:nth-child(1) {
                        color: #f7b500;
                        border-color: #f7b500;
                    }
                    &:nth-child(2) {
                        color: #49c376;
                        border-color: #49c376;
                    }
                    &:nth-child(3) {
                        color: rgba(0, 0, 0, 0.9);
                        border-color: rgba(0, 0, 0, 0.9);
                    }
                }
                &.line-change-refund {
                    margin-top: .pxToRem(12) [];
                    height: .pxToRem(48) [];
                    line-height: .pxToRem(48) [];
                    color: rgba(0, 0, 0, 0.9);
                    .change-refund-item {
                        padding-left: .pxToRem(40) [];
                        & + .change-refund-item {
                            margin-left: .pxToRem(24) [];
                        }
                        &.ok {
                            &::after {
                                content: ' ';
                                .base-center-y;
                                left: 0;
                                width: .pxToRem(32) [];
                                height: .pxToRem(32) [];
                                background: url('~@/assets/icons/icon-ok-green.png');
                                background-size: cover;
                            }
                        }
                        &.no {
                            &::after {
                                content: ' ';
                                .base-center-y;
                                left: 0;
                                width: .pxToRem(32) [];
                                height: .pxToRem(32) [];
                                background: url('~@/assets/icons/icon-close-red.png');
                                background-size: cover;
                            }
                        }
                    }
                    .change-refund-more {
                        text-align: right;
                        padding-right: .pxToRem(24) [];
                        flex: 1;
                        color: black;
                        font-weight: bold;
                        &::after {
                            content: ' ';
                            .base-center-y;
                            right: 0;
                            width: .pxToRem(24) [];
                            height: .pxToRem(24) [];
                            background: url(~@/assets/icons/icon-right.png);
                            background-size: cover;
                        }
                    }
                }
            }
            > .line {
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                &.j-s {
                    justify-content: start;
                }
            }
            .coupon-box {
                display: flex;
                height: .pxToRem(60) [];
                line-height: .pxToRem(60) [];
                justify-content: space-between;
                background: linear-gradient(to right, #fdf6ec, #faecdf);
                margin-top: .pxToRem(8) [];
                border-radius: .pxToRem(4) [];
                overflow: hidden;
                .coupon-title {
                    padding-left: .pxToRem(16) [];
                    padding-right: .pxToRem(16) [];
                    color: rgba(0, 0, 0, 0.9);
                    color: #7c5a34;
                    font-weight: bold;
                    .text {
                        z-index: 1;
                    }
                    .bg {
                        position: absolute;
                        top: 0;
                        left: .pxToRem(-4) [];
                        width: .pxToRem(110) [];
                        height: .pxToRem(60) [];
                        background: linear-gradient(to right, #f9e0c2, #e3c09a);
                        transform: skewX(-8deg);
                        z-index: 0;
                    }
                }
                .coupon-text {
                    padding-right: .pxToRem(28) [];
                    margin-right: .pxToRem(16) [];
                    color: #b48d62;

                    &:before {
                        content: ' ';
                        .base-center-y;
                        right: 0;
                        .sq(16);
                        background: url(~@/assets/icons/icon-right-brown.png);
                        background-size: cover;
                    }
                }
            }
            &.no-select {
                // -webkit-filter: grayscale(100%);
                // -moz-filter: grayscale(100%);
                // -ms-filter: grayscale(100%);
                // -o-filter: grayscale(100%);
                // filter: grayscale(100%);
                // filter: gray;
                * {
                    color: #c7c7c7 !important;
                    border-color: #c7c7c7 !important;
                }
            }
            &.select {
                border: 1px solid #cfc2ba;
                border-radius: .pxToRem(20) [];
            }
        }
        .ticket-type-item + .ticket-type-item {
            &::after {
                content: ' ';
                position: absolute;
                top: 0;
                left: .pxToRem(30) [];
                right: .pxToRem(30) [];
                height: .pxToRem(1) [];
                background: rgba(0, 0, 0, 0.15);
                border-radius: .pxToRem(1) [];
            }
        }
        &.small-spacing {
            border-radius: .pxToRem(20) [];
            .tip {
                margin-top: .pxToRem(10) [];
            }
        }
    }

    .accept-adjust-dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 101;
        .content {
            .base-center;
            width: .pxToRem(650) [];
            background: #ffffff;
            border-radius: .pxToRem(40) [];
            .header {
                background: url('~@/assets/icons/icon-dialog-title-bg.png');
                background-size: contain;
                width: .pxToRem(650) [];
                height: .pxToRem(135) [];
                &::before {
                    content: ' ';
                    position: absolute;
                    bottom: .pxToRem(-33) [];
                    left: .pxToRem(206) [];
                    width: .pxToRem(206) [];
                    height: .pxToRem(136) [];
                    background: url('~@/assets/icons/icon-dialog-title-logo.png');
                    background-size: contain;
                }
            }
            .message {
                margin-top: .pxToRem(100) [];
                p {
                    text-align: center;
                    padding: 0 .pxToRem(40) [];
                    line-height: .pxToRem(56) [];
                    font-size: .pxToRem(32) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.9);
                }
            }
            .btn-list {
                display: flex;
                justify-content: space-between;
                margin-top: .pxToRem(56) [];
                margin-bottom: .pxToRem(56) [];
                padding: 0 .pxToRem(50) [];
                .btn-item {
                    width: .pxToRem(260) [];
                    height: .pxToRem(104) [];
                    background: #ffffff;
                    border-radius: .pxToRem(52) [];
                    border: 1px solid #313131;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    p {
                        line-height: .pxToRem(36) [];
                        font-size: .pxToRem(24) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.9);
                        text-align: center;
                    }
                    p:first-child {
                        line-height: .pxToRem(40) [];
                        font-size: .pxToRem(24) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.9);
                        text-align: center;
                    }
                    &.agree {
                        background: @theme_color_first;
                        border: 1px solid @theme_color_first;
                    }
                }
            }
        }
    }
    .keynote {
        color: #d90209;
    }
    .secondary {
        color: rgba(0, 0, 0, 0.5);
    }
    .section-content {
        color: rgba(0, 0, 0, 0.6);
    }
    .link {
        color: #0091ff;
    }
    .popup {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: @footerHeight;
        background: rgba(0, 0, 0, 0.8);
        z-index: 99;
        .tip-message {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
            border-top-left-radius: .pxToRem(40) [];
            border-top-right-radius: .pxToRem(40) [];
            .title {
                height: .pxToRem(106) [];
                line-height: .pxToRem(106) [];
                text-align: center;
                font-size: .pxToRem(32) [];
                font-weight: bold;
                color: rgba(0, 0, 0, 0.9);
                &:after {
                    content: ' ';
                    position: absolute;
                    bottom: 0;
                    left: .pxToRem(50) [];
                    right: .pxToRem(50) [];
                    height: .pxToRem(1) [];
                    background: rgba(0, 0, 0, 0.1);
                }
            }
            .content {
                padding: 0 .pxToRem(50) [];
                padding-bottom: .pxToRem(50) [];
                .bold {
                    margin-top: .pxToRem(30) [];
                    color: rgba(0, 0, 0, 0.9);
                }
                p {
                    margin-top: .pxToRem(10) [];
                    font-size: .pxToRem(28) [];
                    color: rgba(0, 0, 0, 0.5);
                    line-height: .pxToRem(44) [];
                }
            }
            .close {
                position: absolute;
                top: .pxToRem(37) [];
                right: .pxToRem(50) [];
                .sq(32);
            }
        }
    }
    .dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 101;
        .dialog-agreement {
            .base-center;
            width: .pxToRem(650) [];
            background: white;
            border-radius: .pxToRem(40) [];
            .title {
                margin-top: .pxToRem(30) [];
                line-height: .pxToRem(80) [];
                color: #333333;
                font-weight: bold;
                font-size: .pxToRem(36) [];
                text-align: center;
            }
            .content {
                padding: 0 .pxToRem(30) [];
                font-size: .pxToRem(28) [];
                .content-title {
                    font-size: rgba(0, 0, 0, 0.9);
                    font-weight: bold;
                    margin-top: .pxToRem(30) [];
                    font-size: .pxToRem(28) [];
                    height: .pxToRem(48) [];
                    line-height: .pxToRem(48) [];
                    & + .content-line {
                        margin-top: .pxToRem(12) [];
                    }
                    &.ok,
                    &.no {
                        padding-left: .pxToRem(40) [];
                    }
                    &.ok {
                        &::after {
                            content: ' ';
                            .base-center-y;
                            left: 0;
                            width: .pxToRem(32) [];
                            height: .pxToRem(32) [];
                            background: url('~@/assets/icons/icon-ok-green.png');
                            background-size: cover;
                        }
                    }
                    &.no {
                        &::after {
                            content: ' ';
                            .base-center-y;
                            left: 0;
                            width: .pxToRem(32) [];
                            height: .pxToRem(32) [];
                            background: url('~@/assets/icons/icon-close-red.png');
                            background-size: cover;
                        }
                    }
                }
                .content-line {
                    height: .pxToRem(36) [];
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    color: rgba(0, 0, 0, 0.6);
                    &.top-40 {
                        margin-top: .pxToRem(40) [];
                    }
                    .agreement {
                        text-decoration: underline;
                    }
                }
                .line-agree {
                    margin-top: .pxToRem(40) [];
                    margin-bottom: .pxToRem(10) [];
                    text-align: center;
                    color: #666666;
                    font-size: .pxToRem(24) [];
                    .value {
                        padding-left: .pxToRem(40) [];
                        display: inline-block;
                        background: url('~@/assets/icons/icon-unchoose.32.png');
                        background-size: .pxToRem(32) [] .pxToRem(32) [];
                        background-repeat: no-repeat;
                        background-position: left center;
                    }
                    &.ok {
                        .value {
                            background: url('~@/assets/icons/icon-choose.32.png');
                            background-size: .pxToRem(32) [] .pxToRem(32) [];
                            background-repeat: no-repeat;
                            background-position: left center;
                        }
                    }
                }
                .btn {
                    text-align: center;
                    margin: 0 auto;
                    line-height: .pxToRem(80) [];
                    &.btn-agree {
                        width: .pxToRem(560) [];
                        margin-top: .pxToRem(40) [];
                        margin-bottom: .pxToRem(50) [];
                        background: @theme_color_first;
                        border-radius: .pxToRem(40) [];
                        opacity: 0.6;
                        color: #333333;
                        &.ok {
                            opacity: 1;
                        }
                    }
                    &.btn-no {
                        .base-center-x;
                        bottom: .pxToRem(-150) [];
                        color: white;
                    }
                }
            }
            &:before {
                content: ' ';
                position: absolute;
                top: 0;
                background: url('~@/assets/icons/icon-dialog-title-bg.png');
                background-size: contain;
                width: .pxToRem(650) [];
                height: .pxToRem(135) [];
            }
        }
    }
    .footer {
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        padding-left: .pxToRem(30) [];
        padding-right: .pxToRem(30) [];
        box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
        position: fixed;
        bottom: 0;
        font-size: .pxToRem(30) [];
        z-index: 100;
        .box {
            width: 100%;
            height: @footerHeight;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .money {
            font-size: .pxToRem(36) [];
            color: #d90209;
            font-weight: bold;
        }
        .btn {
            padding: .pxToRem(30) [] .pxToRem(65) [];
            background: @theme_color_first;
            border-radius: .pxToRem(80) [];
            font-size: .pxToRem(30) [];
            line-height: .pxToRem(17) [];
            border: none;
        }
        .btn::after {
            border: none;
            content: '';
        }
    }
    .footer-occupy {
        width: 100%;
    }
    .filme-another {
        display: flex;
        justify-content: flex-end;
        margin-top: .pxToRem(10) [];
    }
    .filme-commission {
        font-size: .pxToRem(22) [];
        color: #000000;
        margin-right: .pxToRem(10) [];
        &-num {
            font-size: .pxToRem(24) [];
            color: #ff1e1e;
        }
    }
}
</style>
